import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from "./Login";
import GoogleCallback from "./GoogleCallback";
import Dashboard from "./Dashboard";
import PrivateRoute from "./PrivateRoute";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword"; 
import ResetPassword from "./ResetPassword"; 

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Navigate to="/" />} /> 
        <Route path="/google-callback" element={<GoogleCallback />} />
        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </Router>
  );
};

export default App;